import React from "react";
import { Text } from "@networkraildigitalfactory/components";
import EoyPrepDetail from "./EoyPrepDetail";
import styles from "./ViewReviewPrep.module.css";

const PrepDetail = (props) => {
  const { detail, reviewType } = props;
  const { name, comment } = detail;

  let formattedMessage = comment;
  if (typeof comment === "string" && comment.includes("\n")) {
    formattedMessage = comment.split("\n");
  } else if (!comment) {
    formattedMessage = "No prep completed.";
  }

  // If view review is end of year include interim comments as well as eoy comments
  // eslint-disable-next-line consistent-return
  const viewEoyAndInterimComments = () => {
    if (reviewType === "EOY") {
      return (
        <>
          <EoyPrepDetail detail={detail} />
        </>
      );
    }
  };
  return (
    <div className={styles.prep_detail_wrapper}>
      <Text
        wrapper="span"
        type="body"
        style={{ color: "#353535", fontWeight: 700, paddingLeft: "75px", marginBottom: "12px" }}
      >
        {name}
      </Text>
      {viewEoyAndInterimComments()}
      <div className={styles.detail_row}>
        <Text wrapper="span" type="body" style={{ width: "75px" }}>
          {reviewType}:
        </Text>
      </div>
      <div className={styles.detail_col}>
        <>
          {typeof formattedMessage === "string" ? (
            <Text
              wrapper="p"
              style={{
                marginBottom: "1em",
                color: "#353535",
                textAlign: "justify",
                width: "calc(100% - 75px)",
              }}
            >
              {formattedMessage}
            </Text>
          ) : (
            formattedMessage?.map((line, index) => {
              return (
                <Text
                  wrapper="p"
                  key={index}
                  type="body"
                  style={{
                    marginBottom: "1em",
                    color: "#353535",
                    textAlign: "justify",
                    width: "calc(100% - 75px)",
                  }}
                >
                  {line}
                </Text>
              );
            })
          )}
        </>
      </div>
    </div>
  );
};

export default PrepDetail;
